import React from 'react'
import BudgetsRequests from 'src/app/BudgetsRequests/BudgetsRequests'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { budgetsNeedsApprovalRouteProps } from 'src/navigation/routeProps'

const BudgetsNeedsApprovalAppRoute: AppRoute = {
  id: AppLocation.BudgetsNeedsApproval,
  routeProps: budgetsNeedsApprovalRouteProps,
  component: <BudgetsRequests />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BudgetsNeedsApprovalAppRoute
